import React from "react";

const TextareaInput = React.forwardRef((props, ref) => {
  const {
    containerCls = "",
    inputProps = {},
    label,
    error,
    defaultValue,
  } = props;

  return (
    <div className={`my-4 ${containerCls}`}>
      {label ? <div className="pb-1 text-gray-800">{label}</div> : null}

      <textarea
        type="text"
        className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full ${
          error ? "" : ""
        }`}
        defaultValue={defaultValue}
        rows={4}
        cols={50}
        {...inputProps}
      />

      {error ? (
        <div className="pt-1.5 text-red-600 text-sm">{error}</div>
      ) : null}
    </div>
  );
});

export default TextareaInput;
